import { useState } from 'preact/hooks';
import { Button } from '../ui/Button.jsx';
import { Field } from '../ui/Field.jsx';
import { Sheet } from '../ui/Sheet.jsx';
import { staffList, login } from '../rpc/session.js';
import { useSession } from '../contexts.jsx';

export function SignIn() {
  const { setSession } = useSession();
  const [step, setStep] = useState('code');
  const [code, setCode] = useState('');
  const [staff, setStaff] = useState([]);
  const [picked, setPicked] = useState(null);
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function loadStaff() {
    setBusy(true);
    setError('');
    try {
      const rows = await staffList(code.trim());
      if (!rows.length) throw new Error('BAD_CODE');
      setStaff(rows);
      setStep('pick');
    } catch (e) {
      setError(e.message === 'BAD_CODE' ? 'Unknown event code' : 'Could not reach server');
    } finally {
      setBusy(false);
    }
  }

  async function doLogin() {
    setBusy(true);
    setError('');
    try {
      const s = await login(
        code.trim(),
        picked.name,
        picked.role === 'admin' ? pin : null,
        navigator.userAgent,
      );
      setSession(s);
    } catch (e) {
      setError(e.message === 'BAD_PIN' ? 'Wrong admin PIN' : e.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main style={{ padding: 24, maxWidth: 420, margin: '0 auto' }}>
      <h1>{import.meta.env.VITE_EVENT_LABEL || 'SPS 2026'}</h1>
      {step === 'code' && (
        <Sheet>
          <Field label="Event code">
            <input value={code} onInput={(e) => setCode(e.currentTarget.value)} autoFocus />
          </Field>
          <Button primary block onClick={loadStaff} disabled={!code.trim() || busy}>
            Continue
          </Button>
        </Sheet>
      )}
      {step === 'pick' && (
        <Sheet>
          <Field label="Pick your name">
            <select onChange={(e) => setPicked(staff[e.currentTarget.selectedIndex - 1])}>
              <option value="">—</option>
              {staff.map((s) => (
                <option key={s.name}>
                  {s.name}
                  {s.role === 'admin' ? ' (admin)' : ''}
                </option>
              ))}
            </select>
          </Field>
          {picked?.role === 'admin' && (
            <Field label="Admin PIN">
              <input
                type="password"
                inputMode="numeric"
                value={pin}
                onInput={(e) => setPin(e.currentTarget.value)}
              />
            </Field>
          )}
          <Button variant="primary" block onClick={doLogin} disabled={!picked || busy}>
            Sign in
          </Button>
          <Button block onClick={() => setStep('code')}>
            Back
          </Button>
        </Sheet>
      )}
      {error && <p style={{ color: 'var(--danger)' }}>{error}</p>}
    </main>
  );
}
